import React from 'react';
import PolotnoEditor from '../../components/editor/PolotnoEditor';

interface IProps {
    store: any;
}

const Editor = ({ store }: IProps) => {
    return (
        <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-pt-2 tw-min-w-5xl tw-px-5">
            <PolotnoEditor store={store} />
        </div>
    );
};

export default Editor;
